// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4548":"c38fef53","12752":"d339025f","26764":"7b2faae8","32622":"d339025f","36587":"d339025f","42396":"80b81a22"}[chunkId] + ".chunk.css";
};